import Color from '@/Enums/Color.enum';
import WhitelabelDomainStatus from '@/Enums/Whitelabels/WhitelabelDomainStatus.enum';
import type { ChipProps } from '@mui/material';

const warningChipProps: ChipProps = { sx: { color: Color.WarningText, background: Color.WarningBackground } };
const successChipProps: ChipProps = { sx: { color: Color.AccentGreen, background: Color.SemiTransparentLightGreen } };
const errorChipProps: ChipProps = { sx: { color: Color.AccentRed, background: Color.SemiTransparentRed } };

export const WHITELABEL_DOMAIN_STATUS_CHIP_PROPS: Record<WhitelabelDomainStatus, ChipProps> = {
  [WhitelabelDomainStatus.Pending]: { ...warningChipProps, label: 'Pending' },
  [WhitelabelDomainStatus.AwaitingDnsResponse]: { ...warningChipProps, label: 'Awaiting DNS Response' },
  [WhitelabelDomainStatus.VerifyingCustomDomain]: { ...warningChipProps, label: 'Verifying Custom Domain' },
  [WhitelabelDomainStatus.Success]: { ...successChipProps, label: 'Success' },
  [WhitelabelDomainStatus.FailedWithTimeout]: { ...errorChipProps, label: 'Failed with Timeout' },
  [WhitelabelDomainStatus.Failed]: { ...errorChipProps, label: 'Failed' },
};
